import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeTop12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEdgeTop12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.735 7.46a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75-1.475a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m.5-5.17a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm1.5 9.62a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.5-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3 .75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.25-5.2a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M2.485 3.76a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m7.75-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75 5.2a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeTop12);
